<template>
    <div>
        <div class="content-audit-box">
            <el-tabs v-model="activeName" @tab-remove="removeTab" :tab-position="tabPosition" @tab-click="handleClick">
                <!--<el-tab-pane label="任务发布"  name="one"><task  v-if="activeName === 'one'"></task></el-tab-pane>-->
                <el-tab-pane label="实验报告审批" name="two">
                    <report v-if="activeName === 'two'"></report>
                </el-tab-pane>
                <!-- 精灵助手完善   法律法规-->
                <el-tab-pane label="精灵助手完善" name="three">
                    <assistant v-if="activeName === 'three'"></assistant>
                </el-tab-pane>
                <el-tab-pane label="法律法规" name="four">
                    <regular v-if="activeName === 'four'"></regular>
                </el-tab-pane>
            </el-tabs>

        </div>
    </div>
</template>

<script>
    import regular from './regular/audit-regular'  //规则
    import assistant from './assistant/audit-assistan' //助手
    import task from './taskRelease/audit-taskRelease'
    import report from './vettingReport/audit-vettingReport' //审批

    export default {
        name: "index",
        data() {
            return {
                activeName: 'two',
                tabPosition: 'left'
            }
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            removeTab(name) {
                console.log(name);
            },


        },
        created() {

        },
        components: {
            regular,
            assistant,
            task,
            report
        },
        watch: {
            $route: {
                handler: function (val, oldVal) {
                    console.log(val);
                },
                // 深度观察监听
                deep: true
            }
        }

    }
</script>

<style lang="less" scoped>
    .content-audit-box {
        position: absolute;
        left: 15%;
        width: 75%;
        top: 5vh;
    }
</style>



// WEBPACK FOOTER //
// src/views/audit/index.vue